import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import {unregister} from './registerServiceWorker';
import { I18nProvider } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import { i18n } from "@lingui/core";
import { messages as enMessages } from "./locales/en/messages.js";
import { messages as frMessages } from "./locales/fr/messages.js";
import { getEnvironment } from './utils/themeUtils.js';
import "moment/locale/fr";
import moment from "moment";
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://4c7e45add5e51306dafcd4f17a3fccd5@o4511971088465920.ingest.de.sentry.io/4511971096461392",
    dataCollection: {
        // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
        // userInfo: false,
        // httpBodies: []
    },
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
    ],

    // Tracing - this is currently not turned on because it is causing issues with hub's CORS
    //tracesSampleRate: 1.0, //  Capture 100% of the transactions

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //tracePropagationTargets: ["localhost", "https://pt.ambassadorcruiseline.com", "https://ambassador-digitech-hub.castusdev.co.uk"],

    // Session Replay
    replaysSessionSampleRate: 0.01, // This sets the sample rate at 1%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Enable logs to be sent to Sentry
    enableLogs: true
});


i18n.load({
    en: enMessages,
    fr: frMessages,
  });

  const initialLanguage = getEnvironment("DEFAULT_LANGUAGE") || "en";

  i18n.activate(initialLanguage);
  moment.locale(i18n.locale);
  document.documentElement.lang = i18n.locale;

const container = document.getElementById('root');
const root = createRoot(container);

// Last resort, so a render error degrades to a message instead of blanking the whole app
function AppErrorFallback() {
    return (
        <div className="container mx-auto mt-6">
            <p>
                <Trans id="unexpected_error_try_again">An unexpected error has happened please try again.</Trans>
            </p>
            <button className="action-button action-button-enabled mt-4 px-6" onClick={() => window.location.reload()}>
                <Trans id="try_again">Try again</Trans>
            </button>
        </div>
    );
}

root.render(
    <I18nProvider i18n={i18n}>
      <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
        <App />
      </Sentry.ErrorBoundary>
    </I18nProvider>
);
unregister();
